import React from 'react';

const CustomBlockEditor = ({ block, onUpdate }) => {
  return (
    <div>
      <div className="editor-section">
        <h4 className="editor-section-title">Custom Block</h4>
        <p style={{color: '#999', fontSize: '0.875rem'}}>
          Editor for Custom block coming soon...
        </p>
      </div>
    </div>
  );
};

export default CustomBlockEditor;
